/**
 * Tipos de regiones de envio
 */
enum RegionTypes {
    Country = 'country',
    AdminDivision = 'admin_division',
}

export default RegionTypes
